import Vue from 'vue'
import * as moment from 'moment'
import { ShippingsService, ShippingsGuestService, CommentsService, FavoriteService } from '@/common/api.service'
import {
  FETCH_SHIPPING,
  FETCH_SHIPPING_GUEST,
  FETCH_COMMENTS,
  COMMENT_CREATE,
  COMMENT_DESTROY,
  FAVORITE_ADD,
  FAVORITE_REMOVE,
  SHIPPING_PUBLISH,
  SHIPPING_EDIT,
  SHIPPING_DELETE,
  SHIPPING_RESET_STATE
} from './actions.type'
import {
  RESET_STATE,
  SET_SHIPPING,
  SET_COMMENTS,
  UPDATE_SHIPPING_IN_LIST
} from './mutations.type'

const initialState = {
  shipping: {
    id: '',
    vehicle_type_id: null,
    from_place_id: null,
    from_extra: null,
    from_contact: null,
    from_email: null,
    from_phone: null,
    from_meta: null,
    to_place_id: null,
    to_extra: null,
    to_contact: null,
    to_email: null,
    to_phone: null,
    to_meta: null,
    description: null,
    status: null,
    receiver_type_id: null,
    receiver_first_name: null,
    receiver_last_name: null,
    receiver_address_street: null,
    receiver_address_number: null,
    receiver_address_extra: null,
    receiver_phone: null,
    receiver_signature: null,
    receiver_comments: null,
    price: null,
    courier_commission: null,
    currency: null,
    payment_method_id: null,
    area_id: null,
    user_id: null,
    courier_id: null,
    address_from: {},
    address_to: {},
    payment_method: {},
    area: {},
    courier: {},
    current_tracking: {},
    photos: [],
    status_history: []
  },
  comments: []
}

export const state = Object.assign({}, initialState)

export const actions = {
  [FETCH_SHIPPING](context, shippingSlug) {
    return ShippingsService.get(shippingSlug, { includes: ['courier.courier_available', 'company', 'status_history', 'notifications_close_to_arrive', 'previousShipping', 'followingShippings', 'items'] })
      .then(({ data }) => {
        context.commit(SET_SHIPPING, data)
        return data
      })
  },
  [FETCH_SHIPPING_GUEST](context, params) {
    const includes = ['courier', 'company', 'status_history', 'notifications_close_to_arrive', 'shipping_type']
    let fields
    if (!params.reverse) {
      fields = 'id,to_contact,address_to,to_place_id,to_extra,to_meta,to_country_iso_code,company,fields_revision,fields_revision_data,courier,current_tracking,status,status_history,tour_id,created_at,updated_at,company.id,company.name,company.country_iso_code,courier.name,courier.profile_picture,notifications_close_to_arrive,shipping_type'
      if (params.hash) {
        includes.push('company.settings')
        fields = fields + ',to_email,to_phone,company.settings.name,company.settings.pivot.value'
      }
    } else {
      fields = 'id,from_contact,address_from,from_place_id,from_extra,from_meta,from_country_iso_code,company,fields_revision,fields_revision_data,courier,current_tracking,status,status_history,tour_id,created_at,updated_at,company.id,company.name,company.country_iso_code,courier.name,courier.profile_picture,notifications_close_to_arrive,shipping_type'
      if (params.hash) {
        includes.push('company.settings')
        fields = fields + ',from_email,from_phone,company.settings.name,company.settings.pivot.value'
      }
    }
    return ShippingsGuestService.get(params.id, {
      hash: params.hash,
      includes,
      fields
    })
      .then(({ data }) => {
        context.commit(SET_SHIPPING, data)
        return data
      })
  },
  [FETCH_COMMENTS](context, shippingSlug) {
    return CommentsService.get(shippingSlug)
      .then(({ data }) => {
        context.commit(SET_COMMENTS, data.comments)
      })
  },
  [COMMENT_CREATE](context, payload) {
    return CommentsService
      .post(payload.slug, payload.comment)
      .then(() => { context.dispatch(FETCH_COMMENTS, payload.slug) })
  },
  [COMMENT_DESTROY](context, payload) {
    return CommentsService
      .destroy(payload.slug, payload.commentId)
      .then(() => {
        context.dispatch(FETCH_COMMENTS, payload.slug)
      })
  },
  [FAVORITE_ADD](context, payload) {
    return FavoriteService
      .add(payload)
      .then(({ data }) => {
        // Update list as well. This allows us to favorite an shipping in the Home view.
        context.commit(
          UPDATE_SHIPPING_IN_LIST,
          data.shipping,
          { root: true }
        )
        context.commit(SET_SHIPPING, data.shipping)
      })
  },
  [FAVORITE_REMOVE](context, payload) {
    return FavoriteService
      .remove(payload)
      .then(({ data }) => {
        // Update list as well. This allows us to favorite an shipping in the Home view.
        context.commit(
          UPDATE_SHIPPING_IN_LIST,
          data.shipping,
          { root: true }
        )
        context.commit(SET_SHIPPING, data.shipping)
      })
  },
  [SHIPPING_PUBLISH]({ state }) {
    return ShippingsService.create(state.shipping)
  },
  [SHIPPING_DELETE](context, slug) {
    return ShippingsService.destroy(slug)
  },
  [SHIPPING_EDIT]({ state }) {
    return ShippingsService.update(state.shipping.slug, state.shipping)
  },
  [SHIPPING_RESET_STATE]({ commit }) {
    commit(RESET_STATE)
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_SHIPPING](state, shipping) {
    state.shipping = shipping
    state.shipping.created_at = moment.utc(shipping.created_at)
    state.shipping.scheduled_date = moment.utc(shipping.scheduled_date)
  },
  [SET_COMMENTS](state, comments) {
    state.comments = comments
  },
  [RESET_STATE]() {
    for (const f in state) {
      Vue.set(state, f, initialState[f])
    }
  }
}

const getters = {
  shipping(state) {
    return state.shipping
  },
  comments(state) {
    return state.comments
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
